import type { ReactNode } from "react";
import { useT } from "../i18n/index.js";

/** Login/register backdrop: dark ground, gold title, tagline. */
export function AuthFrame({ children }: { children: ReactNode }) {
  const t = useT();
  return (
    <div
      style={{
        minHeight: "100%",
        display: "grid",
        placeItems: "center",
        padding: "calc(var(--safe-top) + 24px) 16px calc(var(--safe-bottom) + 24px)",
        background: "radial-gradient(1200px 600px at 50% -10%, rgba(245,197,66,0.14), transparent 60%), radial-gradient(800px 500px at 80% 110%, rgba(34,211,238,0.12), transparent 60%), var(--bg-0)",
      }}
    >
      <div style={{ width: "min(420px, 100%)" }}>
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <div style={{ fontSize: 44, fontWeight: 900, letterSpacing: "0.12em", color: "var(--gold)", textShadow: "0 0 24px rgba(245,197,66,0.45)" }}>{t("app.name")}</div>
          <div className="dim" style={{ fontSize: 14 }}>{t("app.tagline")}</div>
        </div>
        {children}
      </div>
    </div>
  );
}
